"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _react = _interopRequireWildcard(require("react"));

var _UIAvatar = _interopRequireDefault(require("./UIAvatar"));

var UISimpleAvatar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UISimpleAvatar, _Component);

  function UISimpleAvatar() {
    (0, _classCallCheck2.default)(this, UISimpleAvatar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UISimpleAvatar).apply(this, arguments));
  }

  (0, _createClass2.default)(UISimpleAvatar, [{
    key: "render",
    value: function render() {
      _devLogger.default.warn({
        message: 'UISimpleAvatar is depreciated, please use UIAvatar or UIImage please',
        key: 'UISimple-avatar-is-out'
      });

      return _react.default.createElement(_UIAvatar.default, this.props);
    }
  }]);
  return UISimpleAvatar;
}(_react.Component);

UISimpleAvatar.propTypes = _UIAvatar.default.propTypes;
var _default = UISimpleAvatar;
exports.default = _default;
module.exports = exports.default;